import { useQuery, useLazyQuery } from "@apollo/client";
import { useMemo, useEffect, useState } from "react";
import { useStatsigClient } from "@statsig/react-bindings";
import { useRecoilValue } from "recoil";

import { HOMEPAGE_CONTENT_FEED } from "../../GraphQL/homepage";
import { useUser } from "../../Hooks/useUser";

import { PLAYLIST } from "MVVM/GraphQL/playlist";
import { ProContentExperimentState } from "MVVM/State/embeddablePlaylist";

const limit = 12;

const HomepageViewModel = () => {
  const { allstarUser } = useUser();
  const { getExperiment } = useStatsigClient();
  const startDate = useMemo(
    () => String(new Date(new Date().setMonth(new Date().getMonth() - 12))),
    [],
  );
  const [playlistId, setPlaylistId] = useState<string | null>("");
  const [isProFeedFetching, setIsProFeedFetching] = useState(false);
  const showProContent = useRecoilValue(ProContentExperimentState);

  let personalized = false;
  if (allstarUser.loggedIn) {
    personalized = getExperiment("personalized_for_you").get(
      "personalized",
      false,
    );
  }

  const { data: contentFeeds, loading: contentFeedsLoading } = useQuery(
    HOMEPAGE_CONTENT_FEED(personalized),
    {
      variables: {
        limit,
        search: "popular",
        startDate,
      },
      fetchPolicy: "cache-and-network",
    },
  );

  const [fetchMe, { data: prosFeed, loading: prosFeedLoading }] =
    useLazyQuery(PLAYLIST);

  useEffect(() => {
    async function fetchData() {
      setIsProFeedFetching(true);
      const response = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/cs/clips/playlist?limit=60&sort=score&expiry=1h&age=7d`,
        {
          headers: {
            "X-API-KEY": process.env.REACT_APP_PLAYLIST_API_KEY || "",
          },
        },
      );
      const data = await response.json();

      if (data.data.playlistUrl) {
        const url = new URL(data.data.playlistUrl);
        const playlistId = url.searchParams.get("playlist");
        if (playlistId) {
          setPlaylistId(playlistId);
        }
      }
    }

    if (showProContent) {
      fetchData();
    }
  }, [showProContent]);

  useEffect(() => {
    if (playlistId) {
      (async () => {
        await fetchMe({
          variables: { id: playlistId },
        }).then(() => {
          setIsProFeedFetching(false);
        });
      })();
    }
  }, [playlistId, fetchMe]);

  return {
    allstarUser,
    contentFeeds,
    contentFeedsLoading,
    prosFeedLoading: isProFeedFetching || prosFeedLoading,
    prosFeed: prosFeed?.playlist?.clips,
  };
};

export { HomepageViewModel };
